import * as Mixins from "./Mixins";
import type { Theme } from "../types/Theme";

/** Block-start padding for `.question` from WithinComponents; halved under modern theme. */
export function resolveQuestionWithinComponentPadding(theme: Theme): number {
    const within = Mixins.getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents);
    return within / (theme.UseModernTheme ? 2 : 1);
}

/** Inline margin/padding for non-fieldset grouping questions and their legends. */
export function resolveNonFieldsetGroupingInlineEdge(theme: Theme): string {
    return theme.UseModernTheme ? "0" : "2px";
}
